{
  "name": "vanex-cdt",
  "version": "2026.8.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --watch --configuration local --host 0.0.0.0 --port=4202",
    "build": "ng build",
    "build:dev": "ng build --configuration dev --output-hashing=all && node scripts/write-build-info.mjs",
    "build:prod": "ng build --configuration production --output-hashing=all && node scripts/write-build-info.mjs",
    "watch": "ng build --watch --configuration dev",
    "test": "ng test",
    "test:ci": "ng test --browsers=ChromeHeadless --watch=false",
    "test:scripts": "node --test \"scripts/*.test.mjs\"",
    "parcours:mettre-a-jour": "node scripts/mettre-a-jour-parcours.mjs",
    "test:e2e": "npx playwright test",
    "format": "prettier --write \"src/**/*.{ts,html,scss,css,json,md}\"",
    "lint": "ng lint"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@11.7.0",
  "dependencies": {
    "@angular/cdk": "~22.2.4",
    "@angular/common": "^22.2.3",
    "@angular/compiler": "^22.2.3",
    "@angular/core": "^22.2.3",
    "@angular/forms": "^22.2.3",
    "@angular/material": "~22.2.4",
    "@angular/material-moment-adapter": "^22.2.4",
    "@angular/platform-browser": "^22.2.3",
    "@angular/router": "^22.2.3",
    "@fortawesome/angular-fontawesome": "^5.1.0",
    "@fortawesome/free-solid-svg-icons": "^7.3.1",
    "@lucide/angular": "^1.61.0",
    "@popperjs/core": "^2.11.8",
    "bootstrap": "^5.3.8",
    "flag-icons": "^7.6.0",
    "i18n-iso-countries": "^7.14.0",
    "intl-tel-input": "^27.1.3",
    "keycloak-angular": "^22.0.0",
    "keycloak-js": "^26.2.4",
    "markdown-it": "^15.0.3",
    "microdiff": "^1.6.0",
    "ngx-color-picker": "^20.1.1",
    "pdfjs-dist": "^6.4.299",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^22.2.4",
    "@angular/cli": "^22.2.4",
    "@angular/compiler-cli": "^22.2.3",
    "@angular/localize": "^22.2.3",
    "@ng-bootstrap/ng-bootstrap": "^21.0.0",
    "@playwright/test": "^1.64.1",
    "@types/jasmine": "^6.0.0",
    "angular-eslint": "22.6.0",
    "eslint": "^9.39.2",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "^5.13.0",
    "jsdom": "^27.1.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.3.0",
    "prettier": "^3.9.10",
    "ts-prune": "^0.10.3",
    "typescript": "~6.0.3",
    "typescript-eslint": "8.72.0",
    "vitest": "^4.0.8"
  }
}
